import { render, staticRenderFns } from "./ForgotPasword.vue?vue&type=template&id=6efaa85c&scoped=true&"
import script from "./ForgotPasword.vue?vue&type=script&lang=js&"
export * from "./ForgotPasword.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasword.vue?vue&type=style&index=0&id=6efaa85c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efaa85c",
  null
  
)

export default component.exports